import {FormGroup} from '@angular/forms';

/**
 * Detects if a string contains HTML tags (more robust than simple regex)
 * Handles HTML fragments from WYSIWYG editors
 */
const containsHtmlTags = (value: string): boolean => {
  const htmlPattern = /<\/?[a-zA-Z][a-zA-Z0-9]*(?:\s[^<>]*)?\/?>|&[a-zA-Z0-9#]+;/;
  if (/<|>/.test(value)) {
    return htmlPattern.test(value);
  }

  return false;
};

const extractTextContent = (value: string): string => {
  try {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = value;
    return tempDiv.textContent || tempDiv.innerText || '';
  } catch (__error) {
    return value;
  }
};

const trimFormValue = (form: FormGroup, key: string): void => {
  const value = form.value[key];
  if (!value || typeof value !== 'string') return;

  if (containsHtmlTags(value)) {
    const textContent = extractTextContent(value);

    if (textContent.trim() === '') {
      form.patchValue({[key]: null});
    } else {
      form.patchValue({[key]: value.trim()});
    }
  } else {
    form.patchValue({[key]: value.trim()});
  }

  form.updateValueAndValidity();
};

export {trimFormValue};
